// hooks/useAiModel.js
import { useState, useEffect } from 'react';
import { DEFAULT_AI_MODEL, AI_MODELS } from '../constants/aiConstants';

const LEGACY_MODEL_MAP = {
  'gemini-1.5-pro': 'gemini-2.5-flash',
  'gemini-2.0-flash': 'gemini-2.5-flash'
};

export const useAiModel = () => {
  const [currentModel, setCurrentModel] = useState(DEFAULT_AI_MODEL);
  
  // Load saved preference from localStorage on component mount
  useEffect(() => {
    const savedModel = localStorage.getItem('preferredAiModel');
    if (savedModel) {
      const migratedModel = LEGACY_MODEL_MAP[savedModel] || savedModel;
      const isKnownModel = AI_MODELS.some(model => model.id === migratedModel);

      if (isKnownModel) {
        setCurrentModel(migratedModel);
        if (migratedModel !== savedModel) {
          localStorage.setItem('preferredAiModel', migratedModel);
        }
      } else {
        setCurrentModel(DEFAULT_AI_MODEL);
        localStorage.setItem('preferredAiModel', DEFAULT_AI_MODEL);
      }
    }
  }, []);
  
  // Save preference when it changes
  const changeModel = (newModel) => {
    setCurrentModel(newModel);
    localStorage.setItem('preferredAiModel', newModel);
  };
  
  return {
    currentModel,
    changeModel
  };
};

export default useAiModel;
